<template>
<div>
    <v-data-iterator
      :items="propAccount"
      class="profit"
      content-tag="div"
      :content-class="'layout row wrap'"
      hide-actions >
      <template slot="header">
        <v-toolbar class="mb" color="primary" dark  flat>
          <v-toolbar-title>Prop Account</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        <v-toolbar class="mb" color="white white--text" flat>
          <v-layout row>
            <v-flex>
              <v-autocomplete
              dense 
              flat
              clearable
              item-text="name"
              return-object
              :items="firmsByBrand"
              label="Select Firm"
              v-model="selectedFirm"
              ></v-autocomplete>
            </v-flex>
            <v-spacer/>
            <v-flex>
              <v-menu
                v-model="fromdatepicker"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  clearable
                  v-model="filterInvoiceFrom"
                  single-line
                  label="From Date"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="filterInvoiceFrom" @input="fromdatepicker = false" />
              </v-menu>
            </v-flex>
            <v-flex>
              <v-menu
                v-model="todatepicker"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  clearable
                  v-model="filterInvoiceTo"
                  label="To Date"
                  single-line
                  readonly
                ></v-text-field>
                <v-date-picker v-model="filterInvoiceTo" @input="todatepicker = false" />
              </v-menu>
            </v-flex>
          </v-layout>
        </v-toolbar>
      </template>

      <template slot="item" slot-scope="props">
        <v-flex xs6 md6 sm6 v-if="props.item.expense">
          <v-card>
            <v-card-title class="primary white--text">
              <b>Particulars</b>
              <v-spacer/> Amount
            </v-card-title>
          </v-card>
          
          <!-- Opening Stock --> 
          <v-card v-if="!!selectedFirm"> 
            <!-- <v-card-title >
              <b> Opening Stock</b>
              <v-spacer />
              <h3>{{ selectedFirm.openingStock || 0 | amount}}</h3>
            </v-card-title> -->
          </v-card>

          <!-- Start of expense in prop Capital Account-->
          <div style="margin-top:3px;">
           <expand-card
            :hasItems="groupExpensesOfPropCapital.length > 0"
            :value="propexpenseTotal  || 0 | amount"
          >  
            <template slot="header"> 
              <b class="subheading font-weight-bold" v-if="groupExpensesOfPropCapital.length != 0">Expenses</b>
              <b class="subheading font-weight-bold" v-if="groupExpensesOfPropCapital.length === 0">No Expense !</b>
            </template>
            
            <template slot="items">
              <template v-for="(expense, e) in groupExpensesOfPropCapital" >
              <v-expansion-panel-content v-if="expense.totalAmount > 0"
                :key="e"
              >
              <div slot="header">
                 <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-light">{{ expense.expense }}</b> / {{ expense.category }}
                    <v-spacer />
                    <h3>{{ Number.parseFloat(expense.totalAmount) + Number.parseFloat(expense.openingBalance) || 0 | amount }}</h3>
                  </v-card-title>
                </v-card>
              </div>
                <v-list dense>
                <v-list-tile v-for="(section, i) in expense.invoices" :key="i">
                  <v-list-tile-content>{{ new Date(section.date).toLocaleDateString('en-IN')  }}</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ section.totalAmount || section.openingBalance || '-'}}</v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-expansion-panel-content>
            </template>
            </template>  
          </expand-card>
        </div>
        <!-- End of Expense Account in Prop Capital account -->
 

        <!-- Start of Dep Asset in Prop capital Account   -->
        <v-expansion-panel expand>
            <v-expansion-panel-content :key="'12-a'">
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <h3>Depriciation</h3>
                    <v-spacer />
                    <h3>{{ proptotalAsset || 0 | amount }}</h3>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <v-list-tile v-for="(asset, i) in propassetByBrand" :key="i">
                  <v-list-tile-content>{{ asset.asset}}/ {{ asset.category }}</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ asset.depAmount || 0 | amount }}</v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        <!-- End Of Depriciation Asset -->   

        <!-- Purchase Stock --> 
          <v-card>
            <!-- <v-card-title>
              <b> Purchase</b>
              <v-spacer />
              <h3>{{ purchase | amount}}</h3>
            </v-card-title> -->
          </v-card>


          <!-- All Direct Expense -->   
          <div style="margin-top:3px;">
           <!-- <expand-card
            :hasItems="groupExpenses.length > 0"
            :value="expenseTotal || 0 | amount"
            >   -->
            <!-- <template slot="header"> 
              <h3 v-if="groupExpenses.length != 0">Expenses</h3>
              <h3 v-if="groupExpenses.length === 0">No Expense !</h3>
            </template> -->
            
            <template slot="items">
              <template v-for="(expense, e) in groupExpensesOfTradingAccount" >
                <v-expansion-panel-content v-if="expense.totalAmount > 0 || expense.openingBalance > 0"
                  :key="e"
                >
                <div slot="header">
                  <v-card>
                    <!-- <v-card-title>
                      <b>{{ expense.expense }}</b> / {{ expense.category }}
                      <v-spacer />
                      <h3>{{ Number.parseFloat(expense.totalAmount) + Number.parseFloat(expense.openingBalance) || 0 | amount }}</h3>
                    </v-card-title> -->
                  </v-card>
                </div>
                <v-list dense>
                  <v-list-tile v-for="(section, i) in expense.invoices" :key="i">
                    <v-list-tile-content>{{ new Date(section.date).toLocaleDateString('en-IN')  }}</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{ section.totalAmount || section.openingBalance || '-'}}</v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-expansion-panel-content>
            </template>
          </template>  
          <!-- </expand-card> -->
        </div>  
        <!-- End of Expense -->

        <v-card>
            <!-- <v-card-title v-if="grossProfit < 0">
              <b>Gross Loss c/d</b>
              <v-spacer />
              <h3>{{ grossProfit || 0 | amount}}</h3>
            </v-card-title> -->
        </v-card>
        <!-- Start of expense -->
          <div style="margin-top:3px;">
            <!-- <expand-card
              :hasItems="groupExpensesOfPandL.length > 0"
              :value="pandlexpenseTotal  || 0 | amount"
            >  
              <template slot="header"> 
                <h3 class="font-weight-bold" v-if="groupExpensesOfPandL.length != 0">Expenses</h3>
                <h3 class="font-weight-bold" v-if="groupExpensesOfPandL.length === 0">No Expense !</h3>
              </template> -->
            
              <template slot="items">
                <template v-for="(expense, e) in groupExpensesOfPandL" >
                  <v-expansion-panel-content v-if="expense.totalAmount > 0 || expense.openingBalance > 0"
                  :key="e">
                    <div slot="header">
                      <v-card>
                        <!-- <v-card-title>
                          <b class="primary--text font-weight-light">{{ expense.expense }}</b> / {{ expense.category }}
                          <v-spacer />
                          <h3 class="primary--text font-weight-light">{{ Number.parseFloat(expense.totalAmount) + Number.parseFloat(expense.openingBalance) || 0 | amount }}</h3>
                        </v-card-title> -->
                      </v-card>
                    </div>
                    <v-list dense>
                      <v-list-tile v-for="(section, i) in expense.invoices" :key="i">
                        <v-list-tile-content>{{ new Date(section.date).toLocaleDateString('en-IN')  }}</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{ section.totalAmount || section.openingBalance || '-'}}</v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-expansion-panel-content>
                </template>
              </template>  
            <!-- </expand-card> -->
          </div>
        <!-- End of Expense -->

        <!-- Start of Staff -->  
        <v-expansion-panel expand>
          <v-expansion-panel-content> 
            <!-- <div slot="header"> 
              <v-card>
                <v-card-title>
                  <b>Staff</b>
                  <v-spacer />
                  <h3>{{ totalSalary | amount }}</h3>
                </v-card-title>
              </v-card>  
            </div> -->
  
            <v-expansion-panel expand>
              <v-expansion-panel-content v-for="(staff, e) in getStaffAccount" :key="e">
                <div slot="header">
                  <v-card>
                    <!-- <v-card-title>
                      <b class="primary--text font-weight-light">{{ staff.staffName }}</b> | {{ staff.staffRole }}
                      <v-spacer />
                      <h3 class="primary--text font-weight-light">{{ staff.creditTotal - staff.debitTotal | amount }}</h3>
                    </v-card-title> -->
                  </v-card>
                </div>
                <!-- <v-data-table
                  :items="staff.salaryList"
                  class="elevation"
                  :headers="salaryListHeaders"
                  hide-actions
                > 
                  <template slot="items" slot-scope="props">
                    <td>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</td>   
                    <v-spacer/>             
                    <template v-if="props.item.isCredited">
                      <td><h4 class = "success--text align-end">₹ {{props.item.amount | amount}}</h4></td>
                    </template>
                    <v-spacer/>
                    <template v-if="!props.item.isCredited">
                      <td><h4 class = "error--text align-end"> ₹ {{props.item.amount | amount}}</h4></td>
                    </template>
                  </template>
                  <template slot="no-data">
                    no record found
                  </template>
                </v-data-table> -->
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panel-content>
        </v-expansion-panel> 
        <!-- End of Staff-->

        <!-- Depriciation Asset -->  
        <v-expansion-panel expand>
            <v-expansion-panel-content :key="'12-e'">
              <!-- <div slot="header">
                <v-card>
                  <v-card-title>
                    <b>Depriciation</b>
                    <v-spacer />
                    <h3>{{ totalAsset || 0 | amount }}</h3>
                  </v-card-title>
                </v-card>
              </div> -->
              <v-list dense>
                <v-list-tile v-for="(asset, i) in assetByBrand" :key="i">
                  <v-list-tile-content>{{ asset.asset}}/ {{ asset.category }}</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ asset.depAmount || 0 | amount }}</v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        <!-- End of Dep asset-->
        
        <!-- Start of net profit from profit and loss account -->
        <v-card>
            <v-card-title v-if="netProfit < 0">
              <b>Net Loss c/d</b>
              <v-spacer />
              <h3>{{ netProfit || 0 | amount}}</h3>
            </v-card-title>
        </v-card>
        <!-- End of net profit from profit and loss account -->

        
        <!-- Closing Balance of Prop Capital -->
          <v-card v-if="!!selectedFirm">
            <v-card-title>
              <b>Closing Balance</b>
              <v-spacer />
              <h3>{{ closingBalance || 0 | amount }}</h3>
            </v-card-title>
          </v-card>
        <!-- End of Closing Balance  of Prop capital Account-->
        
        <v-card>
            <v-card-title class="primary white--text">
              <b>Total</b>
              <v-spacer />
              <h3>{{  Number.parseFloat(propexpenseTotal) + Number.parseFloat(proptotalAsset) + Number.parseFloat(closingBalance)   -  Number.parseFloat(netProfit &lt; 0 ? netProfit : 0 ) | amount }}</h3>
            </v-card-title>
        </v-card>
    </v-flex>
    <v-flex xs6 md6 sm6 v-if="!props.item.expense">
        <v-card>
            <v-card-title class="primary white--text">
              <b>Particulars</b>
              <v-spacer/> Amount
            </v-card-title>
          </v-card>

          <!-- Opening Balance in Prop Capital Account --> 
          <v-card v-if="!!selectedFirm"> 
            <v-card-title >
              <b> Opening Balance</b>
              <v-spacer />
              <h3>{{ selectedFirm.openingBalance || 0 | amount}}</h3>
            </v-card-title>
          </v-card>

          <!-- <v-card v-if="!!selectedFirmDetail">
            <v-card-title>
              <b>Opening Balance</b><v-spacer /><h3>{{ selectedFirmDetail.openingBalance || 0 | amount}}</h3>
            </v-card-title>
          </v-card> -->
          
          <!-- Start Of Income in Prop Capital -->
          <div style="margin-top:3px;">
            <expand-card
              :hasItems="groupIncomesOfPropCapital.length > 0"
              :value="propincomeTotal || 0 | amount"
            >  
            <template slot="header"> 
              <b class="subheading font-weight-bold" v-if="groupIncomesOfPropCapital.length != 0">Incomes</b>
              <b class="subheading font-weight-bold" v-if="groupIncomesOfPropCapital.length === 0">No Other Income !</b>
            </template>
            
            <template slot="items">
              <template v-for="(income, e) in groupIncomesOfPropCapital" >
                <v-expansion-panel-content  v-if="income.totalAmount > 0" :key="e">
                  <div slot="header">
                    <v-card>
                      <v-card-title>
                        <b class="primary--text font-weight-light">{{ income.income }}</b> / {{ income.category }}
                        <v-spacer />
                        <h3 class="primary--text font-weight-light">{{ Number.parseFloat(income.totalAmount) + Number.parseFloat(income.openingBalance) || 0 | amount }}</h3>
                      </v-card-title>
                    </v-card>
                  </div>
                  <v-list dense>
                    <v-list-tile v-for="(section, i) in income.invoices" :key="i">
                      <v-list-tile-content>{{ new Date(section.date).toLocaleDateString('en-GB')  }}</v-list-tile-content>
                      <v-list-tile-content class="align-end">{{ section.totalAmount || section.openingBalance || 0 | amount}}</v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-expansion-panel-content>
              </template>
            </template>  
          </expand-card>
        </div>
        <!-- End of Income in Prop Capital -->     
          
        <v-card>
            <!-- <v-card-title>
              <b>Sales</b>
              <v-spacer />
              <h3>{{ sales | amount}}</h3>
            </v-card-title> -->
          </v-card>


        <!-- Start Income List -->
        <div style="margin-top:3px;">
          <!-- <expand-card
            :hasItems="groupIncomes.length > 0"
            :value="incomeTotal || 0 | amount"
          >   -->
            <!-- <template slot="header"> 
              <h3 class="subheading font-weight-bold" v-if="groupIncomes.length != 0">Incomes</h3>
              <h3 class="subheading font-weight-bold" v-if="groupIncomes.length === 0">No Other Income !</h3>
            </template> -->
            
            <template slot="items">
              <template v-for="(income, e) in groupIncomesOfTradingAccount" >
                <v-expansion-panel-content  v-if="income.totalAmount > 0 || income.openingBalance > 0" :key="e">
                  <div slot="header">
                    <v-card>
                      <!-- <v-card-title>
                        <b class="primary--text font-weight-light">{{ income.income }}</b> / {{ income.category }}
                        <v-spacer />
                        <h3 class="primary--text font-weight-light">{{ Number.parseFloat(income.totalAmount) + Number.parseFloat(income.openingBalance) || 0 | amount }}</h3>
                      </v-card-title> -->
                    </v-card>
                  </div>
                  <v-list dense>
                    <v-list-tile v-for="(section, i) in income.invoices" :key="i">
                      <v-list-tile-content>{{ new Date(section.date).toLocaleDateString('en-GB')  }}</v-list-tile-content>
                      <v-list-tile-content class="align-end">{{ section.totalAmount || section.openingBalance || 0 | amount}}</v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-expansion-panel-content>
              </template>
            </template>  
          <!-- </expand-card> -->
        </div>
        <!-- Start of closing Stock -->
        <v-card>
            <!-- <v-card-title>
              <b>Closing Stock</b>
              <v-spacer />
              <h3>{{ closingStock || 0 | amount }}</h3>
            </v-card-title> -->
          </v-card>
          <v-card>
            <!-- <v-card-title v-if="grossProfit >= 0">
              <b>Gross Profit c/d</b>
              <v-spacer />
              <h3>{{ grossProfit || 0 | amount }}</h3>
            </v-card-title> -->
          </v-card>
          <div style="margin-top:3px;">
            <!-- <expand-card
              :hasItems="groupIncomes.length > 0"
              :value="pandlincomeTotal || 0 | amount"
            >   
              <template slot="header"> 
                <b class="subheading font-weight-bold" v-if="groupIncomes.length != 0">Incomes</b>
                <b class="subheading font-weight-bold" v-if="groupIncomes.length === 0">No Other Income !</b>
              </template> -->
            
              <template slot="items">
                <template v-for="(income, e) in groupIncomes" >
                  <v-expansion-panel-content  v-if="income.totalAmount > 0 || income.openingBalance >0 " :key="e">
                    <div slot="header">
                      <v-card>
                        <!-- <v-card-title>
                          <b>{{ income.income }}</b> / {{ income.category }}
                          <v-spacer />
                          <h3>{{ Number.parseFloat(income.totalAmount) + Number.parseFloat(income.openingBalance) || 0 | amount }}</h3>
                        </v-card-title> -->
                      </v-card>
                    </div>
                    <v-list dense>
                      <v-list-tile v-for="(section, i) in income.invoices" :key="i">
                        <v-list-tile-content>{{ new Date(section.date).toLocaleDateString('en-GB')  }}</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{ section.totalAmount || section.openingBalance || 0 | amount}}</v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-expansion-panel-content>
                </template>
              </template>  
            <!-- </expand-card> -->
        </div>

        <!-- Net loss -->  
        <v-card>
            <v-card-title v-if="netProfit > 0">
              <b>Net profit c/d</b>
              <v-spacer />
              <h3>{{ netProfit || 0 | amount}}</h3>
            </v-card-title>
        </v-card>

        <!-- total right side -->
        <v-card>
            <v-card-title class="primary white--text">
              <b>Total</b>
              <v-spacer />
              <!-- <h3>{{ Number.parseFloat(pandlincomeTotal || 0 |amount) + Number.parseFloat(grossProfit || 0 |amount) + Number.parseFloat(netProfit &lt; 0 ? netProfit : 0)| amount }}</h3> -->
              <!-- <h3>{{ Number.parseFloat(pandlincomeTotal || 0 |amount) + + Number.parseFloat((grossProfit > 0 ? grossProfit : 0 ) | amount) + Number.parseFloat(netProfit &lt; 0 ? netProfit : 0)| amount }}</h3> -->
              <!-- <h3>{{ Number.parseFloat(propincomeTotal) + Number.parseFloat(proptotalAsset) + Number.parseFloat(openingBalance) + Number.parseFloat(netProfit > 0 ? netProfit : 0 ) | amount }}</h3> -->
              <!-- <h3>{{ (this.selectedFirm ? (Number.parseFloat(this.selectedFirm.openingBalance) || 0) : 0)}} </h3> -->
              <h3>{{ Number.parseFloat(propAllTotal) + Number.parseFloat(netProfit > 0 ? netProfit : 0 ) | amount }}</h3>
            </v-card-title>
          </v-card>
        </v-flex>
      </template>
    </v-data-iterator>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import ExpandCard from '../Balancesheet/expandCard';
const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']

  export default {
    components: {
      ExpandCard,
    },
    data: () => ({
        propAccount: [
        {
          expense: true
        },
        {
          expense: false
        }
      ],
      expenseTotal : 0,
      pandlexpenseTotal: 0,
      propexpenseTotal: 0,
      incomeTotal : 0,
      pandlincomeTotal: 0,
      propincomeTotal: 0,
      selectedFirm: null, 
      filterInvoiceFrom: null,
      filterInvoiceTo: null,
      fromdatepicker: false,
      todatepicker: false,  
      totalSalary : 0,
      totalAsset : 0,
      proptotalAsset : 0,
      searchInput: null,
      selectedStaff : {},
      salaryListHeaders: [
                { text: 'Date', value: 'date', sortable: true},
                { text: 'Credit/Debit', value: 'amount', sortable: false},
      ],
      sale : {
          total : 0,
          list : [],
          expand : false
      },
    }),
    created() {
      this.$bindAsArray('invoices', this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear))
      this.$bindAsArray('expenses', this.$root.$firebaseRefs.expenses)
      this.$bindAsArray('firms', this.$root.$firebaseRefs.firm)
      this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer)
      this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller)
      this.$bindAsArray('incomes',this.$root.$firebaseRefs.incomes)
      this.$bindAsArray('salarys', this.$root.$firebaseRefs.salarys)
      this.$bindAsArray('staff',this.$root.$firebaseRefs.staff)
      this.$bindAsArray('assets', this.$root.$firebaseRefs.assets)
    },
    computed: {
      ...mapGlobalGetters(['selectedBrand','brandFinYear']),
    //   selectedFirmDetail() {
    //     if(!this.selectedFirm) { return null }
    //     return this.firms.find(item => item['.key'] === this.selectedFirm)
    //   },
      sales(){
        let totalSale = 0;
        let buyers = this.buyers.filter(item => item["brand"] === this.selectedBrand);
        let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
        let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
        buyers.map((buyer)=>{
            let sales = this.invoices.filter((item) => 
            item['brand'] === this.selectedBrand && 
            item['buyerId'] == buyer['.key'] &&
            (this.selectedFirm ? item['firm'] === this.selectedFirm['.key'] : true) &&
            (fromDate ? item.date >= fromDate : true) &&
            (toDate ? item.date <= toDate : true));
          sales.map((inv)=>{
            totalSale += (inv.totalAmount ? Number.parseFloat(inv.totalAmount) : 0)
          })
        })
        totalSale = Number.parseFloat(totalSale).toFixed(2);
        return totalSale;
      },
      purchase(){
        let totalPurchase = 0;
        let sellers = this.sellers.filter(item => item["brand"] === this.selectedBrand);
        let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
        let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
          sellers.map((buyer)=>{
          let purchase = this.invoices.filter((item) => 
          item['brand'] === this.selectedBrand && 
          item['buyerId'] == buyer['.key'] &&
          (this.selectedFirm ? item['firm'] === this.selectedFirm['.key'] : true) &&
          (fromDate ? item.date >= fromDate : true) &&
          (toDate ? item.date <= toDate : true));
          purchase.map((inv)=>{
            totalPurchase += (inv.totalAmount ? Number.parseFloat(inv.totalAmount) : 0)
          })
        })
        totalPurchase = Number.parseFloat(totalPurchase).toFixed(2);
        return totalPurchase;
      },
      // current brands firm list
      firmsByBrand () {
        // return selected brand firms
        return this.firms
          .filter((item) => item['brand'] === this.selectedBrand)
      },
      groupExpensesOfTradingAccount(){
            this.expenseTotal = 0;
            let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
            let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
            let expenses = this.expenses.filter(expense => expense.brand === this.selectedBrand);
            expenses = expenses.filter(expense => !!expense['.key']);
            expenses.map((ex,index)=>{
            let openingBalance = 0;
            let totalAmount = 0;
            let paymentTypeStatus = 'confirm';
            let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["expenseType"] === ex['.key'] && 
            (this.selectedFirm ? invoice['firm'] === this.selectedFirm['.key'] : true) &&
            (fromDate ? invoice.date >= fromDate : true) &&
            (toDate ? invoice.date <= toDate : true))
            invoices.map((inv)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            if(paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
            }
            });
            expenses[index]['invoices'] = invoices;
            expenses[index].paymentTypeStatus = paymentTypeStatus;
            expenses[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
            expenses[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
            this.expenseTotal += (isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance)) + (isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount));
            })
            this.expenseTotal = Number.parseFloat(this.expenseTotal).toFixed(2)
        return expenses;
      },
      groupIncomesOfTradingAccount(){
        this.incomeTotal = 0;
            let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
            let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
            let incomes = this.incomes.filter(income => income.brand === this.selectedBrand);
            incomes = incomes.filter(income => !!income['.key']);
            incomes.map((ex,index)=>{
            let openingBalance = 0;
            let totalAmount = 0;
            let paymentTypeStatus = 'confirm';
            let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["incomeType"] === ex['.key'] && 
            (this.selectedFirm ? invoice['firm'] === this.selectedFirm['.key'] : true) &&
            (fromDate ? invoice.date >= fromDate : true) &&
            (toDate ? invoice.date <= toDate : true))
            invoices.map((inv)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            if(paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
            }
            });
            incomes[index]['invoices'] = invoices;
            incomes[index].paymentTypeStatus = paymentTypeStatus;
            incomes[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
            incomes[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
            this.incomeTotal += (isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance)) + (isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount));
            })
            this.incomeTotal = Number.parseFloat(this.incomeTotal).toFixed(2)
        return incomes;
      },
      groupExpensesOfPandL(){
          this.pandlexpenseTotal = 0;
          let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
          let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
          let expenses = this.expenses.filter(expense => expense.brand === this.selectedBrand && expense.underHead === 'Profit and Loss');
          expenses = expenses.filter(expense => !!expense['.key']);
          expenses.map((ex,index)=>{
          let openingBalance = 0;
          let totalAmount = 0;
          let paymentTypeStatus = 'confirm';
          let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["expenseType"] === ex['.key'] && 
          (this.selectedFirm ? invoice['firm'] === this.selectedFirm['.key'] : true) &&
          (fromDate ? invoice.date >= fromDate : true) &&
          (toDate ? invoice.date <= toDate : true))
          invoices.map((inv)=>{
          openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
          totalAmount += Number.parseFloat(inv.totalAmount)
          if(paymentTypeStatus == 'confirm') {
          paymentTypeStatus = inv.paymentTypeStatus;
          }
          });
          expenses[index]['invoices'] = invoices;
          expenses[index].paymentTypeStatus = paymentTypeStatus;
          expenses[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
          expenses[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
          this.pandlexpenseTotal += (isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance)) + (isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount));
          })
          this.pandlexpenseTotal = Number.parseFloat(this.pandlexpenseTotal).toFixed(2)
        return expenses;
      },
      getStaffAccount () {
        this.totalSalary = 0;
            if (this.selectedBrand) {
              const staffList = this.staff.filter(item => item['brand'] === this.selectedBrand && (this.selectedFirm ? item['firm']  === this.selectedFirm['.key'] : true))      
                const result = staffList.map(e => {
                    const salaryList = _.filter(this.salarys, { 'staffId': e['.key'], });
                    e.salaryList = salaryList;
                    const creditTotal = _.sumBy(salaryList, function (s) {
                        if(s.isCredited)
                            return s.amount
                    });

                    e.creditTotal = creditTotal ? creditTotal :0;

                    const debitTotal = _.sumBy(salaryList, function (s) {
                        if(!s.isCredited)
                            return s.amount
                    });

                     e.debitTotal = debitTotal ? debitTotal : 0;
          
                     this.totalSalary = this.totalSalary + ( parseInt(e.creditTotal) - parseInt(e.debitTotal) ) ;
                    return e;
                })
                console.log(result,null,4)
                return result;
            }
        },
        assetByBrand() {
         if (this.assets) {
          this.totalAsset = 0;
          let selectedAssets = this.assets.filter(asset => {
            return asset.brand === this.selectedBrand && asset['category'] != 'personal' && asset['depriciation']    
          });
          selectedAssets.map((ast,index)=>{
            let firmAsset = this.invoices.filter(item => 
              item['assetType'] === ast['.key'] &&
              item['brand'] === this.selectedBrand &&
              (this.selectedFirm ? ast.firm === this.selectedFirm['.key'] : true)
              )
              let openingBalance = 0;
              firmAsset.map((inv)=>{
                  openingBalance += (inv.openingBalance ? parseInt(inv.openingBalance) : 0);
              });
              selectedAssets[index]['openingBalance'] = openingBalance;
              selectedAssets[index]['depAmount'] = this.getDepAmount(ast,ast.type);
              if(ast.category ==='b&p') {
                selectedAssets[index]['depAmount'] = selectedAssets[index]['depAmount']/2;
              }
              this.totalAsset += selectedAssets[index]['depAmount'];
            })
            return selectedAssets;
            }
          return [];
        },
        propassetByBrand() {
         if (this.assets) {
          this.proptotalAsset = 0;
          let selectedAssets = this.assets.filter(asset => {
            return asset.brand === this.selectedBrand && asset['category'] != 'business' && asset['depriciation'] 
          });
          selectedAssets.map((ast,index)=>{
            let firmAsset = this.invoices.filter(item => 
              item['assetType'] === ast['.key'] &&
              item['brand'] === this.selectedBrand &&
              (this.selectedFirm ? ast['firm'] === this.selectedFirm : true)
              )
              let openingBalance = 0;
              firmAsset.map((inv)=>{
                  openingBalance += (inv.openingBalance ? parseInt(inv.openingBalance) : 0);
              });
              selectedAssets[index]['openingBalance'] = openingBalance;
              selectedAssets[index]['depAmount'] = this.getDepAmount(ast,ast.type);
              if(ast.category ==='b&p') {
                selectedAssets[index]['depAmount'] = selectedAssets[index]['depAmount']/2;
              }
              this.proptotalAsset += selectedAssets[index]['depAmount'];
            })
            return selectedAssets;
            }
          return [];
        },
        groupIncomes(){
            this.pandlincomeTotal = 0;
            let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
            let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
            let incomes = this.incomes.filter(income => income.brand === this.selectedBrand && income.underHead === 'Profit and Loss');
            incomes = incomes.filter(income => !!income['.key']);
            incomes.map((ex,index)=>{
            let openingBalance = 0;
            let totalAmount = 0;
            let paymentTypeStatus = 'confirm';
            let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["incomeType"] === ex['.key'] && 
            (this.selectedFirm ? invoice['firm'] === this.selectedFirm['.key'] : true) &&
            (fromDate ? invoice.date >= fromDate : true) &&
            (toDate ? invoice.date <= toDate : true))
            invoices.map((inv)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            if(paymentTypeStatus == 'confirm') {
                paymentTypeStatus = inv.paymentTypeStatus;
            }
            });
            incomes[index]['invoices'] = invoices;
            incomes[index].paymentTypeStatus = paymentTypeStatus;
            incomes[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
            incomes[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
            this.pandlincomeTotal += (isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance)) + (isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount));
            })
            this.pandlincomeTotal = Number.parseFloat(this.pandlincomeTotal).toFixed(2)
            return incomes;
        },
        groupExpensesOfPropCapital(){
            this.propexpenseTotal = 0;
            let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
            let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
            let expenses = this.expenses.filter(expense => expense.brand === this.selectedBrand &&  expense.underHead === 'Prop Capital A/C');
            expenses = expenses.filter(expense => !!expense['.key']);
            expenses.map((ex,index)=>{
            let openingBalance = 0;
            let totalAmount = 0;
            let paymentTypeStatus = 'confirm';
            let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["expenseType"] === ex['.key'] && 
            (this.selectedFirm ? invoice['firm'] === this.selectedFirm['.key'] : true) &&
            (fromDate ? invoice.date >= fromDate : true) &&
            (toDate ? invoice.date <= toDate : true))
            invoices.map((inv)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            if(paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
            }
            });
            expenses[index]['invoices'] = invoices;
            expenses[index].paymentTypeStatus = paymentTypeStatus;
            expenses[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
            expenses[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
            this.propexpenseTotal += (isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance)) + (isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount));
            })
            this.propexpenseTotal = Number.parseFloat(this.propexpenseTotal).toFixed(2)
            return expenses;
        },
        groupIncomesOfPropCapital(){
        this.propincomeTotal = 0;
            let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
            let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
            let incomes = this.incomes.filter(income => income.brand === this.selectedBrand &&  income.underHead === 'Prop Capital A/C');
            incomes = incomes.filter(income => !!income['.key']);
            incomes.map((ex,index)=>{
            let openingBalance = 0;
            let totalAmount = 0;
            let paymentTypeStatus = 'confirm';
            let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["incomeType"] === ex['.key'] && 
            (this.selectedFirm ? invoice['firm'] === this.selectedFirm['.key'] : true) &&
            (fromDate ? invoice.date >= fromDate : true) &&
            (toDate ? invoice.date <= toDate : true))
            invoices.map((inv)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            if(paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
            }
            });
            incomes[index]['invoices'] = invoices;
            incomes[index].paymentTypeStatus = paymentTypeStatus;
            incomes[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
            incomes[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
            this.propincomeTotal += (isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance)) + (isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount));
            })
            this.propincomeTotal = Number.parseFloat(this.propincomeTotal).toFixed(2)
        return incomes;
      },
      // groupIncomes(){
      //      const mainGroup = [] // { details: {} && invoices: []}
      //   try {
      //     this.incomesByBrand.forEach(details => {
      //       const invoices = this.invoiceByBrand.filter(invoice => {
      //         return invoice.incomeType === details['.key'];
      //       })
      //       details.totalAmount = invoices.reduce((total, item) => {
      //         return total + item.totalAmount  
      //       }, 0)
      //       details.openingBalance = invoices.reduce((total, item) => {
      //         return total + item.openingBalance  
      //       }, 0)
      //       if(details.totalAmount) {
      //         mainGroup.push({
      //           details,
      //           invoices
      //         }) 
      //       }
      //       else if(details.openingBalance) {
      //         mainGroup.push({
      //           details,
      //           invoices
      //         }) 
      //       }
      //     })
      //     return mainGroup
      //   } catch(e) {
      //     console.info(e)
      //     return []
      //   }
      // },
      totalIncomesAmount() {
        return this.groupIncomes.reduce((total, item) => {
         return item.details.totalAmount + total
        }, 0)
      },
      incomesByBrand() {
        const income = this.incomes.filter(income => income.brand === this.selectedBrand && income.underHead === 'Profit and Loss');
        return income;
      },
      incomeInvoices() {
        return this.invoiceByBrand.filter(invoice => !!invoice.incomeType)
      },
      totalIncomeAmount() {
        return this.creditedInvoiceByBrand.reduce((total, item) => {
          // calculate total Income for expense
          return total + Number.parseFloat(item['profit'] || 0)
        }, 0)
      },
      creditedInvoiceByBrand() {
        return this.invoiceByBrand.filter(invoice => {
          if(this.selectedFirm) {
            return invoice.firm === this.selectedFirm['.key'] && invoice.isCredited
           }
          return invoice.isCredited;
         })
       },
      totalIncomesOpeningBalance() {
        return this.groupIncomes.reduce((total, item) => {
         return (isNaN(item.details.openingBalance) ? 0 : item.details.openingBalance) + (isNaN(total) ? 0 : total)
        }, 0)
      },
      invoiceByBrand() {
        if(!this.invoices) { return [] };
        let filter = this.invoices.filter((item) => item['brand'] === this.selectedBrand);
        if(this.selectedFirm) {
          filter = filter.filter(item => item.firm === this.selectedFirm['.key']);
        }
        if(this.filterInvoiceFrom) {
          const from = new Date(this.filterInvoiceFrom).setHours(0,0,0,0);
          filter = filter.filter(item => item.date >= from)
        }
        if(this.filterInvoiceTo) {
          const to = new Date(this.filterInvoiceTo).setHours(23,29,59,999);
          filter = filter.filter(item => item.date <= to)
        }
        return filter;
      },
      closingStock(){
        let closingstock =  (((this.selectedFirm ? (Number.parseFloat(this.selectedFirm.openingStock) || 0) : 0) + 
        Number.parseFloat(this.purchase || 0 | amount)) - (
        Number.parseFloat(this.sales || 0 | amount)));
        closingstock = Number.parseFloat(closingstock).toFixed(2)
        return closingstock;
      },
      closingBalance() {
        let propclosing = ((this.selectedFirm ? (Number.parseFloat(this.selectedFirm.openingBalance) || 0) : 0) + Number.parseFloat(this.propincomeTotal) + Number.parseFloat(this.netProfit)  - (Number.parseFloat(this.proptotalAsset) + Number.parseFloat(this.propexpenseTotal)))
        propclosing = Number.parseFloat(propclosing).toFixed(2)
        return propclosing;
      },
      propAllTotal() {
        let propclosing = ((this.selectedFirm ? (Number.parseFloat(this.selectedFirm.openingBalance) || 0) : 0) + Number.parseFloat(this.propincomeTotal))
        propclosing = Number.parseFloat(propclosing).toFixed(2)
        return propclosing;
      },
      grossProfit(){
        let profit = (( Number.parseFloat(this.sales) + Number.parseFloat(this.incomeTotal) + Number.parseFloat(this.closingStock))
        - ((this.selectedFirm ? (Number.parseFloat(this.selectedFirm.openingStock) || 0) : 0) + 
          Number.parseFloat(this.purchase) +  Number.parseFloat(this.expenseTotal))
        ); 
        profit = Number.parseFloat(profit).toFixed(2);
        return profit;
      },
      netProfit(){
        let netprofit = (( Number.parseFloat(this.pandlincomeTotal) + Number.parseFloat(this.grossProfit) )
        - ( Number.parseFloat(this.totalSalary) + Number.parseFloat(this.totalAsset) +  Number.parseFloat(this.pandlexpenseTotal)) 
        );
        netprofit = Number.parseFloat(netprofit).toFixed(2);
        return netprofit;
      },
    },
    methods:{
      getFirmName(e){
        let firm;
          if (this.firms && this.selectedBrand) {
            firm =this.firms.filter(item => item['.key'] === e)[0]
          }
          if(firm)
          return firm.name
      },
      getDepAmount(asset, type) {
        let depriciation = null;
        if (asset.isVerified && asset.depriciation) {
          const totalAmount = this.getTotalAmount(asset);
          depriciation = Number((totalAmount * asset.depriciation) / 100);
          return depriciation;
        }
        return 0;
      },
      getTotalAmount(asset) {
        if (asset.isVerified) {
            return (
                Number(asset.openingBalance || 0) +
                Number(asset.totalAdditionAmount) -
                Number(asset.totalDeletionAmount)
            );
        }
        return (
            Number(asset.totalAdditionAmount) - Number(asset.totalDeletionAmount)
        );
      }, 
    }
  }
</script>
<style>
.v-data-iterator.profit .v-expansion-panel__header__icon {
  display: none;
}
.v-data-iterator.profit .v-expansion-panel__header {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Informations/Prop/index.vue